export default "__VITE_ASSET__D4nUviy8__"